import React from "react";
import useCreateDelivery from "../hooks/useCreateDelivery";
import { driverLabel, isDeliverySelectable, productCountLabel } from "../model/cnoDeliveryRules";
import { patientLabel } from "../model/cnoRules";
import { CnoModalFrame } from "./CnoModals";
import {
    emptyStyle,
    errorStyle,
    inputStyle,
    labelStyle,
    modalActionsStyle,
    modalStyle,
    primaryButtonStyle,
    secondaryButtonStyle,
} from "./cnoStyles";

const deliveryModalStyle = { ...modalStyle, maxWidth: "640px" };
const patientListStyle = { display: "grid", gap: "8px", maxHeight: "320px", overflow: "auto", paddingRight: "4px" };
const patientOptionStyle = disabled => ({
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
    padding: "10px 12px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    background: disabled ? "#f8fafc" : "white",
    color: disabled ? "#94a3b8" : "#122A26",
});

function DeliveryPatientOption({ patient, checked, saving, onToggle }) {
    const disabled = !isDeliverySelectable(patient);
    return (
        <label style={patientOptionStyle(disabled)}>
            <input
                type="checkbox"
                aria-label={`Sélectionner ${patientLabel(patient)}`}
                checked={checked}
                disabled={disabled || saving}
                onChange={event => onToggle(patient.id, event.target.checked)}
                style={{ marginTop: "3px", accentColor: "#17B978" }}
            />
            <span style={{ display: "grid", gap: "2px" }}>
                <strong>{patientLabel(patient)}</strong>
                <small>{productCountLabel((patient.cnos || []).length)}</small>
            </span>
        </label>
    );
}

export default function CreateDeliveryModal({ patients, onClose, onCreated }) {
    const delivery = useCreateDelivery(patients, onCreated);
    const { saving } = delivery;

    return (
        <CnoModalFrame
            label="Créer une livraison CNO"
            title="Créer une livraison CNO"
            onClose={onClose}
            closeDisabled={saving}
            style={deliveryModalStyle}
        >
            <form onSubmit={delivery.submit} style={{ display: "grid", gap: "14px" }}>
                {delivery.error && <p role="alert" style={errorStyle}>{delivery.error}</p>}
                <label style={labelStyle}>
                    Date de livraison
                    <input type="date" value={delivery.deliveryDate} onChange={event => delivery.setDeliveryDate(event.target.value)} style={inputStyle} />
                </label>
                <label style={labelStyle}>
                    Livreur
                    <select value={delivery.driverId} onChange={event => delivery.setDriverId(event.target.value)} style={inputStyle} disabled={saving}>
                        <option value="">Aucun livreur assigné</option>
                        {delivery.drivers.map(driver => (
                            <option key={driver.id} value={driver.id}>{driverLabel(driver)}</option>
                        ))}
                    </select>
                </label>
                <div style={patientListStyle}>
                    {patients.length === 0 && <p style={emptyStyle}>Aucun patient CNO disponible.</p>}
                    {patients.map(patient => (
                        <DeliveryPatientOption
                            key={patient.id}
                            patient={patient}
                            checked={delivery.selectedIds.has(patient.id)}
                            saving={saving}
                            onToggle={delivery.toggle}
                        />
                    ))}
                </div>
                <div style={modalActionsStyle}>
                    <button type="button" onClick={onClose} disabled={saving} style={secondaryButtonStyle}>Annuler</button>
                    <button type="submit" disabled={saving} style={{ ...primaryButtonStyle, opacity: saving ? 0.65 : 1 }}>
                        {saving ? "Création..." : "Créer la livraison"}
                    </button>
                </div>
            </form>
        </CnoModalFrame>
    );
}
